export default {
    //波兰语
    DiagnosticReport:'Raport diagnostyczny',
    troubleCode:'kod błędu',
    time:'czas',
    PositioningPrompt:'Włącz funkcję lokalizacji, aby uzyskać lokalne ceny.',
    FaultCode:'Kod awarii',
    AIDiagnosis:'Diagnostyka AI',
    AIWait:'Raport AI lub oczekiwanie na automatyczne diagnozowanie',
    FailedFaultCode:'Nie można uzyskać informacji o kodzie błędu',
    AIError:'AI analiza niepowodzenia',
    more:'więcej',
    StoredCodes:'Potwierdzenie kodu błędu',
    PendingCodes:'Czekaj na kod błędu',
    PermanentCodes:'stałe kod błędu',
    Unknown:'nieznany',
    ManufacturerControl:'określany przez producenta samochodu',
    continue:'Kontynuuj',
    // 引导定位
    notlimits:'Nie można uzyskać uprawnień lokalizacji',
    setupSteps:'Kroki konfiguracji:',
    openset:'Otwórz aplikację "Ustawienia"',
    findSet:'Znajdź aplikację, której używasz',
    clickset:'Kliknij "lokalizacja"',
    selectLimits:'Wybierz "podczas użycia" lub "zawsze"',
    blackRefresh:'Wróć do aplikacji i odśwież stronę',
    openAppSet:'Kliknij "Zarządzanie aplikacjami" lub "Aplikacje"',
    findUseBrowser:'Znajdź używany przez Ciebie przeglądarkę',
    clickAuthority:'Kliknij "Zarządzanie uprawnieniami"',
    findejurisd:'Znajdź uprawnienie "położenie"',
    selectjurisd:'Wybierz "Zezwalaj" lub "Zezwalaj przy użyciu"',
    phoneJurisd:'Sprawdź uprawnienia lokalizacji aplikacji mobilnej:',
    openJurisd:'Włącz uprawnienie "lokalizacja"',
    report:'raport',
    AI:'AI'
}